import { createErrorType } from '@atlassian/mpac-utils';
import SearchFilters from './dla-handlers/SearchFilters';
import { transposeFilterError, transposeFilterOptions } from './dla-handlers/SearchFilters/utils/SearchFilterTransposeUtil';

/**
 * Takes an fetch error object and tries best to parse it
 * into a status code and a response
 */

export async function parseError(error) {
  var _error$response;
  let response;
  if (error.response) {
    try {
      response = await error.response.json();
    } catch (_unused) {
      try {
        response = await error.response.text();
      } catch (_unused2) {
        console.error('parseError: failed to parse response', error);
      }
    }
  }
  return {
    status: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status,
    response
  };
}
export function makeAPIError(_ref) {
  let {
    name,
    code,
    response
  } = _ref;
  const APIError = createErrorType(name);
  return new APIError({
    code,
    message: "".concat(name, " error"),
    meta: {
      response
    }
  });
}
const getFilterById = async (filterId, stargateBaseUrl, statsigClient) => {
  try {
    const options = await SearchFilters({
      filterId,
      stargateBaseUrl,
      statsigClient
    });
    return transposeFilterOptions({
      options,
      filterId
    });
  } catch (error) {
    return transposeFilterError({
      message: error.message,
      filterId
    });
  }
};
const getFilters = async (filterIds, stargateBaseUrl, statsigClient) => {
  if (typeof filterIds === 'string') {
    const filter = await getFilterById(filterIds, stargateBaseUrl, statsigClient);
    return [filter];
  }
  const filters = await Promise.all(filterIds.map(filterId => getFilterById(filterId, stargateBaseUrl, statsigClient)));
  return filters;
};
const convertQueryParamsToSelectedOptions = queryString => {
  const selectedOptions = {};
  const queryParams = new URLSearchParams(queryString);
  for (const [key, value] of queryParams) {
    if (selectedOptions[key]) {
      selectedOptions[key].push(value.toLowerCase());
    } else {
      selectedOptions[key] = [value.toLowerCase()];
    }
  }
  return selectedOptions;
};
const getFilterOptionsFromUrl = _ref2 => {
  let {
    filterOptions,
    search
  } = _ref2;
  const selectedQueryFilters = convertQueryParamsToSelectedOptions(search);
  const selectedOptions = {};
  for (const key in selectedQueryFilters) {
    filterOptions.forEach(filterOption => {
      if (filterOption.filterId === key) {
        selectedOptions[key] = filterOption.options.filter(option => selectedQueryFilters[key].includes(option.id.toLowerCase()));
      }
    });
  }
  return selectedOptions;
};
export const fetchFiltersBeforeSearchResults = async (filterIds, stargateBaseUrl, statsigClient, search, operation) => {
  let selectedOptionsFromURL = {};
  const filterOptions = await getFilters(filterIds, stargateBaseUrl, statsigClient);
  selectedOptionsFromURL = getFilterOptionsFromUrl({
    filterOptions,
    search
  });
  Object.values(selectedOptionsFromURL).forEach(options => {
    options.forEach(option => {
      delete option.__typename;
    });
  });

  // Update operation variables for Apollo cache
  // eslint-disable-next-line require-atomic-updates
  operation.variables.filters = selectedOptionsFromURL;
  return selectedOptionsFromURL;
};